
<nav id="header" class="navbar navbar-expand-lg">
  <!-- *ngIf="url.indexOf('landing') < 0" -->
  <div class="container">
    <a class="navbar-brand" href="/" title="Accueuil">
        <img style="width: 200px" src="assets/imgs/{{logoName}}" id="logo" alt="Logo Akces">
    </a>
    <button class="navbar-toggler navbar-toggler-right" type="button" data-toggle="collapse" data-target="#navbarNavAltMarkup" aria-controls="navbarNavAltMarkup" aria-expanded="false" aria-label="Toggle navigation">
      <i class="fa fa-bars" aria-hidden="true"></i>
    </button>
    <a href="/login/signin"  *ngIf="!loggedIn() || getUser()?.isPreAccount" class="header-login-btn--mini">
      <i class="fa fa-user"></i>
    </a>

    <div *ngIf="!modePro" class="collapse navbar-collapse" id="navbarNavAltMarkup">
      <div class="navbar-nav mr-auto">
        <li class="nav-item">
            <a class="nav-link withe1"  routerLinkActive="active" [routerLink]="['/home']"><i class="fa fa-home"></i></a>
        </li>
        <li class="nav-item">
            <a class="nav-link withe1"  routerLinkActive="active" [routerLink]="['/Concerts']">{{'front_header.concerts'| translate}}</a>
        </li>
        <li class="nav-item">
            <a class="nav-link withe1"  routerLinkActive="active" [routerLink]="['/Clubbing']">{{'front_header.clubbing'| translate}}</a>
        </li>
        <li class="nav-item">
            <a class="nav-link withe1"  routerLinkActive="active" [routerLink]="['/Sports']">{{'front_header.sport'| translate}}</a>
        </li>
        <li class="nav-item">
            <a class="nav-link withe1"  routerLinkActive="active" [routerLink]="['/Festivals']">{{'front_header.festivals'| translate}}</a>
        </li>
        <li class="nav-item">
            <a class="nav-link withe1"  routerLinkActive="active" [routerLink]="['/Spectacles']">{{'front_header.shows'| translate}}</a>
        </li>
        <li class="nav-item">
            <a class="nav-link withe1"  routerLinkActive="active" [routerLink]="['/Plus']">{{'front_header.more'| translate}}</a>
        </li>
        <li class="nav-item dropdown" id="user-dropdown">
            <a class="nav-link header-login-btn btn btn-transparent" routerLinkActive="active" href="/login/signin" *ngIf="!loggedIn() || getUser()?.isPreAccount">
              {{'front_header.log_in'| translate}}
            </a>
            <a id="username" class="btn dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" *ngIf="loggedIn() && !getUser()?.isPreAccount">
                {{ getUser()?.firstname }} {{ getUser()?.lastname }}
            </a>
              <div class="dropdown-menu" aria-labelledby="navbarDropdownMenuLink">
                <a class="dropdown-item" [routerLink]="['/account']">{{'front_header.m_account'| translate}}</a>
                <a class="dropdown-item" [routerLink]="['/tickets']">{{'front_header.tickets'| translate}}</a>
                <a class="dropdown-item" href="{{formatedAppUrl(token)}}">{{'front_header.espace_pro'| translate}}</a>
                <!--<a class="dropdown-item" *ngIf="modePro" [routerLink]="['/manage/organization']">{{'front_header.my_akcesPro'| translate}}</a>
                <a class="dropdown-item" *ngIf="modePro" [routerLink]="['/manage/events']">{{'front_header.my_events'| translate}}</a>
                <a class="dropdown-item"  *ngIf="modePro" [routerLink]="['/manage/payment']">{{'front_header.my_transferts'| translate}}</a>
                <a class="dropdown-item"  *ngIf="modePro" [routerLink]="['/manage/sales']">{{'front_header.my_sales'| translate}}</a>
                <div class="dropdown-divider" *ngIf = 'getUser()?.role_id == 1'></div>
                <a class="dropdown-item"  *ngIf = 'getUser()?.role_id == 1 && modePro' [routerLink]="['/manage/admin/events']">{{'front_header.events'| translate}}</a>
                <a class="dropdown-item"  *ngIf = 'getUser()?.role_id == 1 && modePro' [routerLink]="['/manage/admin/users']">{{'front_header.users'| translate}}</a>
                <a class="dropdown-item"  *ngIf = 'getUser()?.role_id == 1 && modePro' [routerLink]="['/manage/homepage']">{{'front_header.homepage'| translate}}</a>
                <div class="dropdown-divider"></div>-->
                <a class="dropdown-item" href="#" (click)="logout()">{{'front_header.log_out'| translate}}</a>
              </div>
        </li>
        <li class="nav-item dropdown">
          <a class="nav-link dropdown-toggle btn-dropdown-transparent" style="background: transparent; border: none; -webkit-box-shadow: none; box-shadow: none; color: white" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
            <img src="{{curentLangFlag}}" width="30px" alt="Logo Akces"> {{getItem(curentlang)?.toUpperCase()}}
          </a>
          <div  class="dropdown-menu" aria-labelledby="navbarDropdownMenuLink">
            <button class="dropdown-item {{getItem(curentlang) == 'fr' ? 'active' : ' '}}" (click)="useLanguage('fr',$event)" ><img src="assets/imgs/france.png" width="30px" alt="Logo Akces" id="ico-fr"> FR</button>
            <button class="dropdown-item {{getItem(curentlang) == 'en' ? 'active' : ' '}}"  (click)="useLanguage('en',$event)"><img src="assets/imgs/united-kingdom.png" width="30px" alt="Logo Akces" id="ico-en"> EN</button>
          </div>
        </li>
      </div>
    </div>

    <div *ngIf="modePro" class="collapse navbar-collapse" id="navbarNavAltMarkup">
      <div class="navbar-nav mx-auto">
        <li class="nav-item dropdown" id="user-dropdown">
            <a class="nav-link header-login-btn btn btn-transparent" routerLinkActive="active" href="/login/signin" *ngIf="!loggedIn()">{{'front_header.log_in'| translate}}</a>
              <a id="username" class="btn dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" *ngIf="loggedIn()">
                {{ getUser()?.firstname }} {{ getUser()?.lastname }}
              </a>
              <div class="dropdown-menu" aria-labelledby="navbarDropdownMenuLink">
                <a class="dropdown-item" [routerLink]="['/account']">{{'front_header.m_account'| translate}}</a>
                <a class="dropdown-item" *ngIf="modePro" [routerLink]="['/manage/organization']">{{'front_header.my_akcesPro'| translate}}</a>
                <a class="dropdown-item" [routerLink]="['/manage/events']">{{'front_header.my_events'| translate}}</a>
                <a class="dropdown-item"  *ngIf="modePro" [routerLink]="['/manage/payment']">{{'front_header.my_transferts'| translate}}</a>
                <div class="dropdown-divider" *ngIf = 'getUser()?.role_id == 1'></div>
                <a class="dropdown-item"  *ngIf = 'getUser()?.role_id == 1' [routerLink]="['/manage/admin/events']">{{'front_header.events'| translate}}</a>
                <a class="dropdown-item"  *ngIf = 'getUser()?.role_id == 1' [routerLink]="['/manage/admin/users']">{{'front_header.users'| translate}}</a>
                <a class="dropdown-item"  *ngIf = 'getUser()?.role_id == 1' [routerLink]="['/manage/homepage']">{{'front_header.homepage'| translate}}</a>
                <div class="dropdown-divider"></div>
                <a class="dropdown-item" href="#" (click)="logout()">{{'front_header.log_out'| translate}}</a>
              </div>
        </li>
        <li class="nav-item dropdown">
          <a class="nav-link dropdown-toggle btn-dropdown-transparent" style="background: transparent; border: none; -webkit-box-shadow: none; box-shadow: none; color: white" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
            <img src="{{curentLangFlag}}" width="30px" alt="Logo Akces"> {{getItem(curentlang)?.toUpperCase()}}
          </a>
          <div  class="dropdown-menu" aria-labelledby="navbarDropdownMenuLink">
            <div  class="dropdown-item {{getItem(curentlang) == 'fr'?'active':' '}}" (click)="functionUtils.useLanguage('fr',$event)" ><img src="assets/imgs/france.png" width="30px" alt="Logo Akces" id="ico-fr"> FR</div>
            <div  class="dropdown-item {{getItem(curentlang) == 'en'?'active':' '}}"  (click)="functionUtils.useLanguage('en',$event)"><img src="assets/imgs/united-kingdom.png" width="30px" alt="Logo Akces" id="ico-en"> EN</div>
          </div>
        </li>
      </div>
    </div>
  </div>
</nav>
